export class EndorsementConstants {
    additionalInterestType = AdditionalInterestType;
    premiumBasis = PremiumBasis;
}

export const AdditionalInterestType = [
    {id: '1', displayName: 'Additional Insured', value: 'Additional Insured'},
    {id: '2', displayName: 'Employee As Lessor', value: 'Employee As Lessor'},
    {id: '3', displayName: 'Lienholder', value: 'Lienholder'},
    {id: '4', displayName: 'Loss Payee', value: 'Loss Payee'},
    {id: '5', displayName: 'Mortgagee', value: 'Mortgagee'},
    {id: '6', displayName: 'Owner', value: 'Owner'},
    {id: '7', displayName: 'Registrant', value: 'Registrant'},
    {id: '8', displayName: 'Other', value: 'Other'}
]
export const PremiumBasis = [
    {id: '1', displayName: 'Area', value: 'Area'},
    {id: '2', displayName: 'Gross Production', value: 'Gross Production'},
    {id: '3', displayName: 'Gross Sales', value: 'Gross Sales'},
    {id: '4', displayName: 'Payroll', value: 'Payroll'},
    {id: '5', displayName: 'Total Cost', value: 'Total Cost'},
    {id: '6', displayName: 'Unit', value: 'Unit'},
    {id: '7', displayName: 'Other', value: 'Other'}
]
export const UnderlyingCoverage = [
    {id: '1', displayName: 'General Liability', value: 'General Liability'},
    {id: '2', displayName: 'Commercial Auto Liability', value: 'Commercial Auto Liability'},
    {id: '3', displayName: 'Employers Liability', value: 'Employers Liability'},
]
export const RetainedLimit = [
    {id: '1', displayName: '1M', value: '1M'},
    {id: '2', displayName: '2M', value: '2M'},
    {id: '3', displayName: '3M', value: '3M'},
    {id: '4', displayName: '4M', value: '4M'},
    {id: '5', displayName: '5M', value: '5M'}
]